import React from "react";
import './photo.css';

interface PhotoProps{
    /**
     * Variant of photo render
     */
    variant?: 'circle' | 'square',
    /**
     * Photo size
     */
    size?: 'small' | 'medium' | 'large',
    /**
     * Image URL source
     */
    src: string,
    /**
     * Alternative text for image
     */
    alt?: string
}

/**
 * Photo component
 */
export const Photo = ({
    variant = 'circle',
    size = 'medium',
    alt = '',
    src
}: PhotoProps) => {
    return <div className={['photo', 'photo-root', `photo-root--${variant}`, `photo-root--${size}`].join(' ')}>
        <img src={src} alt={alt} className={['photo', 'photo-image', `photo-image--${variant}`, `photo-image--${size}`].join(' ')}/>
    </div>
}